import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { PATHS } from '@/routes/paths'
import { formatMagazineMonth } from '@/lib/magazineUtils'
import { cn } from '@/lib/utils'
import type { MagazineIssue } from '@/data/mock/magazine'

interface EbookEditionCardProps {
  issue: MagazineIssue
  className?: string
  compact?: boolean
  /** Fixed-height layout for home split section */
  split?: boolean
}

export function EbookEditionCard({ issue, className, compact = false, split = false }: EbookEditionCardProps) {
  return (
    <Link
      to={PATHS.magazineDetail(issue.slug)}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'group flex h-full flex-col overflow-hidden rounded-md border border-neutral-200 bg-white shadow-sm transition-all hover:-translate-y-0.5 hover:border-primary-200 hover:shadow-md',
        split && 'min-h-[328px]',
        className,
      )}
    >
      <div
        className={cn(
          'relative min-h-0 flex-1 overflow-hidden bg-neutral-100',
          split ? 'min-h-[220px]' : 'aspect-3/4',
        )}
      >
        <img
          src={issue.coverImage}
          alt={issue.title}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
          loading="lazy"
        />
      </div>
      <div
        className={cn(
          'flex shrink-0 items-center justify-between gap-1.5 bg-primary-700 text-white',
          split ? 'min-h-[48px] px-2.5 py-2' : compact ? 'px-2.5 py-2' : 'gap-2 px-3 py-2.5',
        )}
      >
        <div className="min-w-0">
          <p
            className={cn(
              'truncate font-bold uppercase tracking-wide',
              compact || split ? 'text-[10px]' : 'text-[11px]',
            )}
          >
            {issue.title}
          </p>
          <p className={cn('truncate text-white/75', compact || split ? 'text-[8px]' : 'text-[10px]')}>
            {[formatMagazineMonth(issue.publishedAt, 'short'), issue.city].filter(Boolean).join(' · ')}
          </p>
        </div>
        <ArrowRight className={cn('shrink-0 text-white/90', compact || split ? 'h-3 w-3' : 'h-4 w-4')} aria-hidden />
      </div>
    </Link>
  )
}
